import { z } from 'zod';
import { ReleaseEnvironmentSchema } from '../release-products/shapes';

export const PlanTemplateTodoSchema = z.object({
  title: z.string().trim().min(1).max(300),
  required: z.boolean(),
  isBackup: z.boolean(),
});
export type PlanTemplateTodo = z.infer<typeof PlanTemplateTodoSchema>;

export const PlanTemplateSchema = z.object({
  clickupFilterId: z.string(),
  todos: z.array(PlanTemplateTodoSchema),
});
export type PlanTemplate = z.infer<typeof PlanTemplateSchema>;

export const PlanRowSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  createdByName: z.string(),
  createdAt: z.string(),
  productNames: z.array(z.string()),
});
export type PlanRow = z.infer<typeof PlanRowSchema>;

export const PlanTodoSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  required: z.boolean(),
  isBackup: z.boolean(),
  assigneeUserId: z.string().uuid().nullable(),
  assigneeName: z.string().nullable(),
  completedAt: z.string().nullable(),
});
export type PlanTodo = z.infer<typeof PlanTodoSchema>;

export const PlanSectionSchema = z.object({
  id: z.string().uuid(),
  productId: z.string().uuid(),
  productName: z.string(),
  todos: z.array(PlanTodoSchema),
});
export type PlanSection = z.infer<typeof PlanSectionSchema>;

export const PlanTaskSchema = z.object({
  id: z.string().uuid(),
  ref: z.string(),
  title: z.string(),
  status: z.string(),
  assigneeName: z.string(),
  url: z.string(),
  origin: z.enum(['snapshot', 'sync', 'manual']),
  addedAt: z.string(),
});
export type PlanTask = z.infer<typeof PlanTaskSchema>;

export const PlanLinkedReleaseSchema = z.object({
  id: z.string().uuid(),
  productName: z.string(),
  environment: ReleaseEnvironmentSchema,
  version: z.string(),
  buildNumber: z.number().int(),
  status: z.string(),
});
export type PlanLinkedRelease = z.infer<typeof PlanLinkedReleaseSchema>;

export const PlanDetailSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  createdByName: z.string(),
  createdAt: z.string(),
  sections: z.array(PlanSectionSchema),
  tasks: z.array(PlanTaskSchema),
  releases: z.array(PlanLinkedReleaseSchema),
});
export type PlanDetail = z.infer<typeof PlanDetailSchema>;
